(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceItemCustom', ServiceItemCustom);

    ServiceItemCustom.$inject = ['$resource', 'ENV'];

    function ServiceItemCustom($resource, ENV) {


        var getServiceItemsByCurrentCompany = function () {
            //
            var resourceUrl = ENV.API_BASE_URL + 'api/service-items-by-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getActiveServiceItemsByCurrentCompany = function () {
            //
            var resourceUrl = ENV.API_BASE_URL + 'api/active-service-items-by-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getActiveServiceItemsByCategory = function (categoryid) {
            //
            var resourceUrl = ENV.API_BASE_URL + 'api/active-service-items-by-category/' + categoryid;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceItemsWithOutSchedulingByCurrentCompany = function () {
            //
            var resourceUrl = ENV.API_BASE_URL + 'api/get-service-items-without-scheduling-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getAllAmenitiesType = function () {
            //
            var resourceUrl = ENV.API_BASE_URL + 'api/get-all-amenities-type';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getServiceServants = function (serviceid) {
            //
            var resourceUrl = ENV.API_BASE_URL + 'api/servants-by-service-item/' + serviceid;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var getAutoSelectServant = function (serviceid) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/auto-select-servant?serviceId=' + serviceid;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }
        var createCopyOfServiceItemById = function (serviceItemId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/create-copy-of-service-item-by-id?serviceItemId=' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var getServiceItemsByServantId = function (servantId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-service-item-list-by-servant?servantId=' + servantId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }

        var updateServiceItemFieldByAdmin = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/update-service-item-field-by-admin';
            return $resource(resourceUrl, {}, {}
            );
        }

        var getServiceItemByCurrentCompanyAndServiceMode = function (serviceMode) {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-service-item-list-by-service-mode?serviceMode=' + serviceMode;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceItemWithServantsByCurrentCompany = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-service-item-list-with-servant';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        return {
            getServiceItemsByCurrentCompany: getServiceItemsByCurrentCompany,
            getActiveServiceItemsByCurrentCompany: getActiveServiceItemsByCurrentCompany,
            getActiveServiceItemsByCategory: getActiveServiceItemsByCategory,
            getServiceItemsWithOutSchedulingByCurrentCompany: getServiceItemsWithOutSchedulingByCurrentCompany,
            getAllAmenitiesType: getAllAmenitiesType,
            getServiceServants: getServiceServants,
            getAutoSelectServant: getAutoSelectServant,
            createCopyOfServiceItemById: createCopyOfServiceItemById,
            getServiceItemsByServantId: getServiceItemsByServantId,
            updateServiceItemFieldByAdmin: updateServiceItemFieldByAdmin,
            getServiceItemByCurrentCompanyAndServiceMode: getServiceItemByCurrentCompanyAndServiceMode,
            getServiceItemWithServantsByCurrentCompany: getServiceItemWithServantsByCurrentCompany

        };
    }
})();
